import { render } from "./AnonymousTest.vue?vue&type=template&id=f0ccdd12&scoped=true"
import script from "./AnonymousTest.vue?vue&type=script&lang=js"
export * from "./AnonymousTest.vue?vue&type=script&lang=js"

import "./AnonymousTest.vue?vue&type=style&index=0&id=f0ccdd12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ccdd12"]])

export default __exports__